import { Injectable } from '@angular/core';
import type { PaginationQueryInterface } from '@zaoblako/shared/common/dtos/pagination-query.dto';
import type { HistoryPageInterface } from '@zaoblako/shared/common/dtos/history/history-page.dto';
import type { CreditDebitExclusionFindInterface } from '@zaoblako/shared/modules/document/dtos/credit-debit/credit-debit-exclusion-find.dto';
import type { ReportDescriptorInterface } from '@zaoblako/shared/common/dtos/report/report-descriptor.dto';
import { BaseService } from '@zaoblako/web/core/services/base.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class DebtsExclusionService extends BaseService {
  protected baseUrl = '/debts/debit-credit/exclusion';

  public getRegistryDescriptor(): Observable<ReportDescriptorInterface> {
    return this.http.get<ReportDescriptorInterface>(`${this.baseUrl}/registry-descriptor`);
  }

  public restoreOne(exclusionId: number): Observable<CreditDebitExclusionFindInterface> {
    return this.http.post<CreditDebitExclusionFindInterface>(`${this.baseUrl}/${exclusionId}/restore`, {});
  }

  public getHistory(
    exclusionId: number,
    params: PaginationQueryInterface
  ): Observable<HistoryPageInterface> {
    return this.http.get<HistoryPageInterface>(`${this.baseUrl}/${exclusionId}/history`, {
      params: this.objectToHttpParams(params)
    });
  }
}
